<template>
  <text-input
    :autofocus="false"
    :labelText="labelText"
    :placeholder="placeholder"
    :value="value"
    :onInput="onInputInternal"
    :inputType="'email'"
    :error="error"
    :topLeftLabel="emailErrorLabel"/>
</template>

<script>
import BaseUI from 'base-ui';

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w\w+$/;

export default {
  name: 'EmailInput',
  components: {
    TextInput: BaseUI.TextInput,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    onInput: {
      type: Function,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    onError: {
      type: Function,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    labelText: {
      type: String,
      default: '',
    },
  },
  computed: {
    emailErrorLabel() {
      return this.error ? 'האימייל שהזנת לא תקין' : null;
    },
  },
  methods: {
    async onInputInternal(value) {
      await this.clearEmailError();
      await this.onInput(value);
      await this.calcEmailError();
    },
    async clearEmailError() {
      await this.onError(false);
    },
    async calcEmailError() {
      await this.onError(!emailRegex.test(this.value));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
